export default __webpack_public_path__ + "assets/images/463482908a94e02c3fdfe2f9a261663c.svg";